module.exports = __webpack_public_path__ + "img/truck-ramp-couch.4fc12128.svg";